var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51957 17.7665C7.20783 18.009 6.75753 18.009 6.48043 17.7665L0.938322 13.3329C0.557303 13.0558 0.522665 12.5362 0.79977 12.1552C1.07688 11.8088 1.59645 11.7395 1.97747 12.0512L7 16.0693L12.0225 12.0512C12.3689 11.7395 12.8885 11.8088 13.1656 12.1552C13.4427 12.5362 13.4081 13.0558 13.027 13.3329L7.48493 17.7665H7.51957ZM13.0617 5.40072C13.4081 5.67783 13.4773 6.1974 13.1656 6.54378C12.8885 6.9248 12.3689 6.95944 12.0225 6.68234L7 2.66431L1.97747 6.68234C1.59645 6.95944 1.07688 6.9248 0.79977 6.54378C0.522665 6.1974 0.557303 5.67783 0.938322 5.40072L6.48043 0.967039C6.75753 0.724572 7.20783 0.724572 7.51957 0.967039L13.0617 5.40072Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDown);
export default __webpack_public_path__ + "static/media/ArrowUpDown.5eadb64106ba4919496a43d6209ec511.svg";
export { ForwardRef as ReactComponent };